// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"2a1e30f6","899":"53108a3c"}[chunkId] + ".chunk.js";
};